import React from "react";
import { Link } from "react-router-dom";

const TopicTwo = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Trading Conditions That Work in Your Favor</h1>
        <p>
          Experience tight spreads, fast execution, and complete transparency,
          built to give every trader a fair edge.
        </p>
      </div>
    </div>
  );
};

export default TopicTwo;
